<div class="icbc-alert-box icbc-alert-box-important">
    <img class="icbc-alert-icon" src="assets/images/error.svg">
    <span class="alert-message">{{message}}</span>
</div>
